import { PublicAccessRuleTypes } from '../constants/PublicAccessRuleTypes';
export const isAccessGroupsBasedPublicAccessRuleType = publicAccessRuleType => publicAccessRuleType === PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP;
export const getAccessIds = publicAccessRules => {
  if (!publicAccessRules.length) {
    return [];
  }
  return publicAccessRules[0].ids;
};
export const getAccessIdsLength = publicAccessRules => getAccessIds(publicAccessRules).length;